import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from "react-i18next";
import './Cama.css';
import useColumnsCama from "../../hooks/useColumnsCama";
import { AuthenticationService } from '../../services/authentication.service';
import * as Constants from '../../constants';
import PopUpCama from './NuevaCama';
import CamaService from '../../services/cama.service';
import Table from './TableCama';
import Select from 'react-select'
import HabitacionService from '../../services/habitacion.service';
import { useEstablishment } from '../../Context/EstablishmentContext';
import { FaPlus } from "react-icons/fa";
import { FaFilter } from "react-icons/fa6";
import { IoSearch } from "react-icons/io5";

const Cama = () => {
	const [seen, setSeen] = useState(false);
	const [t] = useTranslation("global");
	const authenticationService = new AuthenticationService();
	const navigate = useNavigate();
	const [listaCamas, setListaCamas] = useState([]);
	const [selectedCama, setSelectedCama] = useState(null);
	const [selectedHabitacion, setSelectedHabitacion] = useState(null);
	const [listaHabitaciones, setListaHabitaciones] = useState([]);

	const [filtroActivo, setFiltroActivo] = useState(1);

	const { establecimiento } = useEstablishment();

	const [listaTiposCama, setListaTiposCama] = useState([])
	const [selectedTipoCama, setSelectedTipoCama] = useState(null);
	const [filtroEdificio, setFiltroEdificio] = useState('');
	const [filtroPlanta, setFiltroPlanta] = useState('');

	const userRol = authenticationService.getAuthenticationSession().user.idTipo;
	const userEstablecimiento = authenticationService.getAuthenticationSession().user.establecimiento;


	useEffect(() => {

		const authentication = authenticationService.getAuthenticationSession();

		if (authentication === null) {
			navigate(Constants.ROUTE_ROOT);

		} else {
			obtenerListaCamas();
			obtenerListaHabitaciones();
			obtenerListaTipoCama();

		}
	}, [navigate, establecimiento]);

	function togglePop() {

		if (selectedCama != null) {
			setSelectedCama(null);
		}

		setSeen(!seen);
	}

	function guardarSelectedCama(cama) {
		setSelectedCama(cama);

	}

	const obtenerListaCamas = async () => {
		if (userRol != Constants.ROLE_USUARIO_TRABAJADOR) {
			await CamaService.getCamas(establecimiento.id)
				.then(response => response.json())
				.then(data => setListaCamas(data));
		} else {
			await CamaService.getCamas(userEstablecimiento)
				.then(response => response.json())
				.then(data => setListaCamas(data));
		}

	}

	const obtenerListaHabitaciones = async () => {
		if (userRol != Constants.ROLE_USUARIO_TRABAJADOR) {
			await HabitacionService.getHabitaciones(establecimiento.id)
				.then(response => response.json())
				.then(data => setListaHabitaciones(data));
		} else {
			await HabitacionService.getHabitaciones(userEstablecimiento)
			.then(response => response.json())
			.then(data => setListaHabitaciones(data));
		} 

	}


	const obtenerListaCamasByParams = async (selectedHabitacion, filtroActivo, selectedTipoCama, selectedEdificio, selectedPlanta) => {
		if (userRol != Constants.ROLE_USUARIO_TRABAJADOR) {
			await CamaService.getCamasByParams(establecimiento.id, selectedHabitacion, filtroActivo, selectedTipoCama, selectedEdificio, selectedPlanta)
				.then(response => response.json())
				.then(data => setListaCamas(data));
		} else {
			await CamaService.getCamasByParams(userEstablecimiento, selectedHabitacion, filtroActivo, selectedTipoCama, selectedEdificio, selectedPlanta)
				.then(response => response.json())
				.then(data => setListaCamas(data));
		}

	}

	const obtenerListaTipoCama = async () => {
		await CamaService.getTiposCama()
			.then(response => response.json())
			.then(data => setListaTiposCama(data));
	}

	const onChangeFiltroHabitacion = (e) => {
		setSelectedHabitacion(e.id)
		obtenerListaCamasByParams(e.id, filtroActivo, selectedTipoCama, filtroEdificio, filtroPlanta);
	}


	const onChangeFiltroTipoCama = (e) => {
		setSelectedTipoCama(e.id)
		obtenerListaCamasByParams(selectedHabitacion, filtroActivo, e.id, filtroEdificio, filtroPlanta);
	}

	const optionsActivo = [
		{ value: 1, label: t('app.label.si') },
		{ value: 0, label: t('app.label.no') }
	];

	const onChangeFiltroActivo = (ev) => {
		setFiltroActivo(ev.value);
		obtenerListaCamasByParams(selectedHabitacion, ev.value, selectedTipoCama, filtroEdificio, filtroPlanta);
	}

	const onChangeFiltroEdificio = (ev) => {
		setFiltroEdificio(ev.target.value)
		obtenerListaCamasByParams(selectedHabitacion, filtroActivo, selectedTipoCama, ev.target.value, filtroPlanta);
	}

	const onChangeFiltroPlanta = (ev) => {
		setFiltroPlanta(ev.target.value)
		obtenerListaCamasByParams(selectedHabitacion, filtroActivo, selectedTipoCama, filtroEdificio, ev.target.value);
	}


	const limpiarFiltros = () => {
		setSelectedHabitacion('');
		setSelectedTipoCama('');
		setFiltroActivo(1);
		setFiltroEdificio('')
		setFiltroPlanta('');
		obtenerListaCamas();
	}
	
	
	/*Configuración de estilos para los selects de los filtros*/
	const colorFiltros = {
	  menuList: styles => ({
	    ...styles,
	    background: '#FAE6F1',
	  }),
	  option: (styles, { isFocused, isSelected }) => ({
	    ...styles,
	    background: isSelected
	        ? '#91005F'
	        : '#FAE6F1',
	    zIndex: 1,
	    "&:hover": {
			background: 'rgba(145, 0, 95, 0.2)',
			color: '#000'
		},
	  }),
	  menu: base => ({
	    ...base,
	    zIndex: 100
	  }),
	}
	
	
	// Para mostrar el color de fondo de la opción elegida en la lista de opciones
	const getOptionValueHabit = option => option.id;
	const getOptionValueTipoCama = option => option.id;

	return (
		<main className="mainContainerPage">
			<section className="principal-container">
				
				<div className={'container-crearComponente'}>
					<h1 className={'title-Componente'}>{t("app.header.enlaces.camas")}</h1>
					
					<button className={'btn-general'} onClick={togglePop}><FaPlus size="10" /><p className="txt-btn-nuevoCompt">{t("app.cama.nuevaCama")}</p></button>

					{seen ? <PopUpCama toggle={togglePop}
						loadCamas={obtenerListaCamas}
						loadCamasByParams={obtenerListaCamasByParams}
						limpiarFiltros={limpiarFiltros}
						selectedHabitacion={selectedHabitacion}
						selectedCama={selectedCama}
						filtroActivo={filtroActivo}
						selectedTipoCama={selectedTipoCama}
						filtroEdificio={filtroEdificio}
						filtroPlanta={filtroPlanta}
						establecimiento={establecimiento.id}
					/> : null}				
				</div>
				
				<div className="container-filtro-tabla">
					<div className="container-filtro-Cama">
						<div className="filtersSearchStyle-Cama">
							<div className="divInputCama">
								<div className="div_img-filtroInputText">
									<IoSearch className="iconSearch" size="20" />
									<input
										placeholder={t("app.placeholder.buscarEdificio")}
										className={'filtroInputText'}
										type="search"
										value={filtroEdificio}
										onChange={onChangeFiltroEdificio}
									/>
								</div>
							</div>
							
							<div className="divInputCama">
								<div className="div_img-filtroInputText">
									<IoSearch className="iconSearch" size="20" />
									<input
										placeholder={t("app.placeholder.buscarPlanta")}
										className={'filtroInputText'}
										type="search"
										value={filtroPlanta}
										onChange={onChangeFiltroPlanta}
									/>
								</div>
							</div>
						</div>
						
						<div className="container-selects-btn-limpiarFiltro-Cama">
							<div className={'filterItemCama'}>
								<label className={'fieldsetLabel'}>{t("app.popup.label.habitacion")}</label>
								<Select
									getOptionValue={getOptionValueHabit}
									className={'filtroSelect'}
									placeholder={t("app.label.seleccionarHabitacion")}
									key={selectedHabitacion || ''}
									value={listaHabitaciones.find(e => e.id === selectedHabitacion || null)}
									onChange={(e) => onChangeFiltroHabitacion(e)}
									options={listaHabitaciones}
									isSearchable={false}
									formatOptionLabel={habitacion => (
										<div>
											<span>{habitacion.numero}</span>
										</div>
									)}
									styles={colorFiltros}
								/>							
							</div>
							
							<div className={'filterItemCama'}>
								<label className={'fieldsetLabel'}>{t("app.popup.label.tipoCama")}</label>
								<Select
									getOptionValue={getOptionValueTipoCama}
									className={'filtroSelect'}
									placeholder={t("app.label.seleccionarTipoCama")}
									key={selectedTipoCama || ''}
									value={listaTiposCama.find(e => e.id === selectedTipoCama || null)}
									onChange={(e) => onChangeFiltroTipoCama(e)}
									options={listaTiposCama}
									isSearchable={false}
									formatOptionLabel={tipo => (
										<div>
											<span>{tipo.nombre}</span>
										</div>
									)}
									styles={colorFiltros}
								/>
							</div>
							
							<div className={'filterItemCama'}>
								<label className={'fieldsetLabel'}>{t("app.popup.label.activo")}</label>
								<Select
									className={'filtroSelect'}
									defaultValue={optionsActivo[0]}
									value={optionsActivo.find(e => e.value === filtroActivo)}
									options={optionsActivo}
									onChange={option => onChangeFiltroActivo(option)}
									isSearchable={false}
									styles={colorFiltros}
								/>
							</div>
							
							<div className={'filterItemCama'}>
								<button className={'btn-limpiarFiltro'} onClick={() => { limpiarFiltros(); obtenerListaCamas(); }}><FaFilter /> <p className="txt-btn-limpiarFiltro">{t("app.cama.limpiarFiltros")}</p></button>
							</div>
						</div>
					</div>
					
					<div className="containerTabla">
						<Table columns={useColumnsCama(togglePop, guardarSelectedCama)} data={listaCamas} />
					</div>
				</div>
			</section>
		</main>
	);
}

export default Cama